import { render } from "./DeleteFromListAction.vue?vue&type=template&id=34a6ed0a"
import script from "./DeleteFromListAction.vue?vue&type=script&lang=ts"
export * from "./DeleteFromListAction.vue?vue&type=script&lang=ts"
script.render = render

export default script